<template>
  <div class="theme_wrapper">
    <button  class="button_themes button-padding" :class="{active: isActive}" v-if="!rename_flag" @dblclick.stop="rename">
      {{theme.name || "_"}}
      <!-- <span class=" clr-black-38 overflow-text">{{theme.name || "_"}}</span> -->
      <!-- <span class="rename_button pointer" v-if="$vuetify.breakpoint.mdAndUp" icon @click.stop="rename"><v-icon size="14">edit</v-icon></span> -->
    </button>
    <div v-else>
      <v-layout align-center>
        <input 
          class="input-themes"
          required
          autofocus 
          v-model="name"
          v-click-outside="renameOk" 
          @keypress.ctrl="renameOk"
        > 
        <!-- <v-text-field @keypress.ctrl="renameOk" v-model="name" label="" required class="px-2"></v-text-field>
        <v-btn icon @click="renameOk">✓</v-btn>
        <DeleteItem @deleteItem="del"/> -->
      </v-layout>
    </div> 
  </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import DeleteItem from '../popups/DeleteItem'
    import ClickOutside from 'vue-click-outside'
    export default {
        name: 'Theme',
        components: {
          DeleteItem
        },
        data() {
          return {
            rename_flag: false,
            name: ''
          }
        },
        props: [
          'theme'
        ],
        methods:{
          rename(){
            this.rename_flag = true
            this.name = this.theme.name
          },
          renameOk(){
            this.renameTheme({_id: this.theme._id, name: this.name}).then(() => {
              this.rename_flag = false
            })
          },
          del(){
            this.delTheme(this.theme._id).then(() => {
              this.rename_flag = false
              const themes_id = this.themes.map(item => item._id)
              this.saveOrderThemes(themes_id)
              if(this.current._id == this.theme._id){
                this.$store.commit('SET_CURRENT', this.themes[0])
                this.$router.push('/')
              }
            })
          },
          ...mapActions(['renameTheme', 'delTheme','saveOrderThemes'])
        },
        computed:{
          ...mapGetters(['current', 'themes']),
          isActive(){
            return this.current && (this.current._id == this.theme._id)
          }
        },
        directives: {
            ClickOutside
        }
    }
</script>

<style lang="scss" scoped>
  .active {
    background: var(--clr-green) !important;
    border:none;
    outline: black !important;  
  }
  .button-padding {
    padding: 0 25px;
  }
  .theme:hover {
    opacity: 1;
  }
</style>

<style lang="scss">
  .theme_wrapper {
    height:84px;
    width: 225px;
    background: #f9f9f9;
  }
</style>